import requestStatuses from '@cinch/oxd-utils/request-status/src'
import { AnyAction } from 'redux'
import * as types from '../types'

export interface VehicleDomainReducer {
  searchStatus: string
}

export interface InitialState {
  searchStatus: string
}

export const initialState: InitialState = {
  searchStatus: requestStatuses.INITIAL,
}

export default (state = initialState, action: AnyAction): VehicleDomainReducer => {
  switch (action.type) {
    case types.DEALER_VEHICLE_SEARCH_REQUEST:
      return { ...state, searchStatus: requestStatuses.PENDING }
    case types.DEALER_VEHICLE_SEARCH_SUCCESS:
      return { ...state, searchStatus: requestStatuses.SUCCESS }
    case types.DEALER_VEHICLE_SEARCH_FAILURE:
      return { ...state, searchStatus: requestStatuses.ERROR }
    default:
      return { ...state }
  }
}
